module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"axe_edge","short_name":"axeedge","start_url":"/","background_color":"#42B2BD","theme_color":"#42B2BD","display":"minimal-ui","icon":"src/images/axeedge-icon.svg","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"4b8ddb889cd92af53ed3fb1c00479ce5"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
